import React from 'react';

const Footer = () => {
    return (
        <div className="bg-gray-900">
            <div className="px-4 pt-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
                <div className="flex flex-col justify-between pt-5 pb-10 border-t border-gray-800 sm:flex-row">
                    <p className="text-sm  font-bold text-orange-500">
                        © Copyright 2022 CODE-STACk.
                    </p>
                  
                </div>
            </div>
        </div>
    );
};

export default Footer;